<template>
  <page-outline :title="titleLabel" :icon="titleIcon">
    <template slot="pageContent">
      <spinner v-if="!details.id || (showOtherDebtors() && otherRTP.length === 0)"></spinner>
      <div v-else>
        <form-accordion :title="'Demandes du groupe'"
          v-if="showOtherDebtors() && otherRTP.length > 1">
          <transactions-list
            filterBy="" itemListStyle="border-radius:0;"
            :actualMessageId="details.id"
            :messages="otherRTP"
            :randomId="randomId"
            :serviceId="services.PAYMENTS">
          </transactions-list>
        </form-accordion>

        <hr v-if="showOtherDebtors() && otherRTP.length > 1" />

        <form-accordion :title="$t('common.request_details')">
          <b-row>
            <b-col sm="6" class="form-group">
              <form-read-group-label-input :inputLabel="$t('common.rsn')"
                :inputValue="details.reason">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-read-group-label-input :inputLabel="$t('common.status.status_label')"
                :inputValue="getStatusLabel(details.status, details.negotStatus)"
                :statusIcon="getStatusIcon(details.status, details.negotStatus)">
              </form-read-group-label-input>
            </b-col>
          </b-row>

          <!-- TLV 25/09/2020 : On affiche le nom et l'e-mail du créancier si c'est le débiteur
          (le destinataire de la RTP) qui regarde. Si le créancier (l'expéditeur de la RTP)
          regarde, on affiche le nom et l'e-mail du débiteur -->
          <b-row>
            <template v-if="details.direction === '0'">
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.crdtr_name')"
                  :inputValue="details.creditorName">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.crdtr_mail')"
                  :inputValue="details.creditorIdentifier">
                </form-read-group-label-input>
              </b-col>
            </template>
            <template v-else-if="details.direction === '1' && !isDebtorAnon">
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.debtor_name')"
                  :inputValue="details.debtorName">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.debtor_email')"
                  :inputValue="details.debtorIdentifier">
                </form-read-group-label-input>
              </b-col>
            </template>
            <template v-else>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.debtor_name')"
                  :inputValue="$t('requestToPay.anon_debtor')">
                </form-read-group-label-input>
              </b-col>
            </template>
          </b-row>

          <b-row>
            <b-col sm="6" class="form-group" v-if="!isDebtorAnon">
              <label class="createInvoiceBandlabelAccordionForm">
                {{ details.direction === '1' ? $t('common.debtor_ibn') : $t('common.my_ibn') }}
              </label>
              <div class="labelAccordionForm" v-if="details.acceptModifyBankAccount === '0' ||
                (details.direction === '1' && paymentMethod === 'application') ||
                (details.direction === '0' && !waitingForAnswerRTP(details.status))">
                <input v-if="details.debtorAccountResponse.length > 0"
                  type="text" disabled="true" class="form-control inputAccordionForm"
                  :value="hideIban(details.debtorAccountResponse)">
                </input>
                <input v-else-if="details.debtorBankAccount.length > 0"
                  type="text" disabled="true" class="form-control inputAccordionForm"
                  :value="hideIban(details.debtorBankAccount)">
                </input>
                <span v-else-if="details.debtorBankAccount.length === 0">Not
                  specified</span>
              </div>
              <div v-if="details.acceptModifyBankAccount === '1' && details.direction === '0' && waitingForAnswerRTP(details.status)"
                class="labelAccordionForm">
                <input v-model="bankAccountSelectDebit"
                  type="text" class="form-control inputAccordionForm"
                  :class="{redBackground: bankAccountSelectDebit === ''}"
                  @focus="showBankAccountSelectionList">
                </input>
                <!-- IRY 17/02/2020
                  Remise en service du selecteur de compte bancaire IBAN (côté receiver de RTP)
                  -->
                <b-col class="bankAccountDebitSelectionListContainer" ref="ibanBox" v-if="showIbanBox">
                  <div class="closeSelectionListContainerLabel" @click="closeSelectionListContainer">
                    <div class="closeSelectionListContainerLabelName">
                      {{ $t('bank_accounts.my_accounts') }}
                    </div>
                    <f7-button round class="orangeBackground rightButton" style="padding:0px 3px;">
                      {{ $t('common.close_label') }}
                    </f7-button>
                  </div>
                  <ul class="bankAccountDebitSelectionList" v-if="bankAccounts.length > 0">
                    <li class="bankAccountDebitSelectionListItem"
                      @click="selectBankAccount($event)" v-for="bankAccount in bankAccounts"
                      :data-iban="bankAccount.iban"
                      :key="bankAccount.iban">
                      <div>{{ bankAccount.iban }}</div>
                      <div>{{ bankAccount.name }}</div>
                    </li>
                  </ul>
                  <ul v-else class="bankAccountDebitSelectionList">
                    <li class="bankAccountDebitSelectionListItem">
                      <div style="text-align: center;">No bank account</div>
                    </li>
                  </ul>
                </b-col>
              </div>
            </b-col>
            <div v-if="details.debtorAccountResponse.length > 0 && details.debtorAccountResponse !== details.debtorBankAccount">
              <b-row class="form-group">
                <b-col class="transactionDetailSubHeader">
                  {{ $t('common.orig_terms') }}
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6" class="form-group">
                  <form-read-group-label-input :inputLabel="$t('common.before_label')"
                    :inputValue="hideIban(details.debtorBankAccount)">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </div>
            <b-col sm="6" class="form-group">
              <form-read-group-label-input
                :inputLabel="details.direction === '0' ? $t('common.crdt_ibn') : $t('common.my_ibn')"
                :inputValue="hideIban(details.creditorBankAccount)">
              </form-read-group-label-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6" class="form-group">
              <form-read-group-label-input :inputLabel="$t('common.rqst_date')"
                :inputValue="details.creationDate | formatDate">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-read-group-label-input :inputLabel="$t('common.end_to_end_id')"
                :inputValue="details.endToEndId">
              </form-read-group-label-input>
            </b-col>
          </b-row>

          <b-row v-if="waitingForAnswerRTP(details.status)">
            <b-col sm="6" class="form-group" v-if="details.direction === '0' && details.acceptModifyAmount === '1'">
              <form-write-group-label-input v-model="details.amount" isMandatory
                inputType="number"
                :inputLabel="$t('common.amnt')"
                :placeholderValue="$t('common.amnt')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group" v-else>
              <form-read-group-label-input :inputLabel="$t('common.amnt')"
                :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group" v-if="details.direction === '0' && details.acceptModifyExecutionDate === '1'">
              <form-write-group-label-input v-model="details.requestedExecutionDate" isMandatory
                inputType="date" disablePastDates :disableFromDate="oldDate"
                :inputLabel="$t('common.exec_date')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group" v-else>
              <form-read-group-label-input :inputLabel="$t('common.exec_date')"
                :inputValue="details.requestedExecutionDate | formatDate">
              </form-read-group-label-input>
            </b-col>
          </b-row>

          <b-row v-else>
            <b-col sm="6" class="form-group" v-if="details.amountResponse.length > 0">
              <form-read-group-label-input :inputLabel="$t('common.amnt')"
                :inputValue="details.amountResponse + ' ' + getCurrencyIcon(details.currency)">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group" v-else>
              <form-read-group-label-input :inputLabel="$t('common.amnt')"
                :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group" v-if="details.executionDateResponse.length > 0">
              <form-read-group-label-input :inputLabel="$t('common.exec_date')"
                :inputValue="details.executionDateResponse | formatDate">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group" v-else>
              <form-read-group-label-input :inputLabel="$t('common.exec_date')"
                :inputValue="details.requestedExecutionDate | formatDate">
              </form-read-group-label-input>
            </b-col>
          </b-row>

          <b-row v-if="details.direction === '0'">
            <b-col class="form-group">
              <b-form-checkbox v-model="details.instantPayment"
                v-if="showInstantPayment(details.debtorBankAccount)"
                class="mt-sm-2" value="1" unchecked-value="0"
                :disabled="!waitingForAnswerRTP(details.status) || isInstantPayment">
                {{ $t('requestToPay.is_inst_payment') }}
                {{ '(' + getBankName(details.debtorBankAccount) + ')' }}
              </b-form-checkbox>
            </b-col>
          </b-row>

          <div v-if="(waitingForAnswerRTP(details.status) && details.negotStatus === '10') ||
            (waitingForAnswerRTP(details.status) && details.negotStatus === '11') ||
            details.status === status.ACCEPTED ||
            details.status === status.MODIFIED ||
            details.status === status.REVOKED ||
            details.status === status.ACCEPTED_AND_PAYED ||
            details.status === status.ACCEPTED_AND_PAYED_INST ||
            details.status === status.MODIFIED_AND_PAYED ||
            details.status === status.MODIFIED_AND_PAYED_INST ||
            details.status === status.ORDER_GENERATED ||
            details.status === status.MADE ||
            details.status === status.INST_MADE">
            <!-- TLV 13/09/2020 Affichage de l'historique du montant et de la date d'exécution, s'il a lieu d'être -->
            <div v-if="((details.amountResponse.length > 0 && details.amountResponse !== details.amount) ||
              (details.executionDateResponse.length > 0 && details.requestedExecutionDate !== details.executionDateResponse))">
              <b-row class="form-group">
                <b-col class="transactionDetailSubHeader">
                  {{ $t('common.orig_terms') }}
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6" class="form-group"
                  v-if="details.amountResponse.length > 0 && details.amountResponse !== details.amount">
                  <form-read-group-label-input :inputLabel="$t('common.orig_amount')"
                    :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group"
                  v-if="details.executionDateResponse.length > 0 && details.requestedExecutionDate !== details.executionDateResponse">
                  <form-read-group-label-input :inputLabel="$t('common.exec_date_orig')"
                    :inputValue="details.requestedExecutionDate | formatDate">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </div>
          </div>

          <!-- ============================== -->
          <!--     INSTALLMENTS       -->
          <!-- ============================== -->
          <b-col sm="6" class="form-group pl-sm-0"
            v-if="details.hasPmtResp === '1' && details.pmtResp.multPmts.length > 0">
            <label class="createInvoiceBand">
              {{ $t('common.pymnts_annoucement', {install_number: details.pmtResp.multPmts.length}) }}
            </label>
            <table class="table table-striped table-bordered table-installment">
              <thead class="thead-dark">
                <tr>
                  <th>{{ $t('common.installment_amount') }}</th>
                  <th>{{ $t('common.installment_date') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(installment, index) in details.pmtResp.multPmts" :key="'installment-' + index">
                  <td>
                    {{ installment.amount + ' ' + getCurrencyIcon(installment.currency) }}
                  </td>
                  <td>{{ installment.date | formatDate }}</td>
                  <td>
                    <span>
                      <f7-icon icon="icon-clock_forward"
                        v-if="installment.pay === '0' || installment.pay === '1'"
                        class="icon-transaction-detail">
                      </f7-icon>
                      <!-- <f7-icon icon="icon-money"
                        v-else-if="installment.pay === '1'"
                        class="icon-transaction-detail">
                      </f7-icon> -->
                      <f7-icon icon="icon-receipt"
                        v-else-if="installment.pay === '2'"
                        class="icon-transaction-detail">
                      </f7-icon>
                      <f7-icon icon="icon-made" v-else
                        class="icon-transaction-detail">
                      </f7-icon>
                      </i>
                    </span>
                  </td>

                </tr>
              </tbody>
            </table>
          </b-col>

          <b-row class="mt-2" v-if="(details.Attachments && details.Attachments.length > 0) || details.lettrage">
            <b-col sm="6" class="form-group" v-if="details.lettrage">
              <b-row>
                <b-col cols="12" class="transactionDetailSubHeader">
                  {{ "Lettrage" }}
                </b-col>
                <b-col cols="12" class="mt-2">
                  {{ details.lettrage && details.lettrage.length > 0 ? formatLettrage(details.lettrage) : 'Pas de lettrage' }}
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="6" class="form-group" v-if="details.Attachments && details.Attachments.length > 0">
              <b-row>
                <b-col cols="12" class="transactionDetailSubHeader">
                  {{ "Document" }}
                </b-col>
              </b-row>
              <b-row v-for="attachment in details.Attachments" :key="attachment.AttachmentId">
                <b-col sm="12" class="form-group">
                  <div class="d-flex justify-content-start">
                    <label id="application-file-input">
                      {{ attachment.AttachmentName }}
                    </label>
                    <div class="d-flex" style="margin-left:5px;">
                      <i class="icon fa fa-download mx-1" @click="view(attachment.AttachmentId)"></i>
                      <i class="icon fa fa-search mx-1" @click="openDoc(attachment.AttachmentId)"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div v-if="showNegotiation()">
            <b-row class="form-group">
              <b-col class="transactionDetailSubHeader">
                Negotiation
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.new_amount')"
                  :inputValue="details.pmtNegot.amountDebtor + ' ' + getCurrencyIcon(details.ccy)">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group"
                v-if="details.pmtNegot.multiPayments.length > 0">
                <label class="createInvoiceBand">
                  {{ $t('common.pymnts_annoucement', {install_number:
                  details.pmtNegot.multiPayments.length}) }}
                </label>
                <table class="table table-striped table-bordered table-installment">
                  <thead class="thead-dark">
                    <tr>
                      <th>{{ $t('common.installment_amount') }}</th>
                      <th>{{ $t('common.installment_date') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pmt, index) in details.pmtNegot.multiPayments" :key="'pmt-' + index">
                      <td>
                        {{ pmt.amount + ' ' + getCurrencyIcon(details.currency) }}
                      </td>
                      <td>
                        {{ pmt.date | formatDate }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

          </div>
          <div v-if="(details.negotStatus === '12')">
            <b-row class="form-group">
              <b-col class="transactionDetailSubHeader">
                Final Terms
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputLabel="$t('common.final_amount')"
                  :inputValue="details.pmtResp.dbtAmt !== ''
                  ? (details.pmtResp.dbtAmt + getCurrencyIcon(details.currency))
                  : (details.amount + getCurrencyIcon(details.currency))">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group"
                v-if="details.pmtResp.multPmts.length > 0">
                <label class="createInvoiceBand">
                  {{ $t('common.pymnts_annoucement', {install_number:
                  details.pmtResp.multPmts.length}) }}
                </label>
                <table class="table table-striped table-bordered table-installment">
                  <thead class="thead-dark">
                    <tr>
                      <th>{{ $t('common.installment_amount') }}</th>
                      <th>{{ $t('common.installment_date') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pmt, index) in details.pmtResp.multPmts" :key="'pmt-' + index">
                      <td>
                        {{ pmt.amount + ' ' + getCurrencyIcon(details.currency) }}
                      </td>
                      <td>
                        {{ pmt.date | formatDate }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </div>
        </form-accordion>

        <hr v-if="details.status === status.REVOKED" />

        <form-accordion :title="$t('common.formsSubTitle.refuse_reason')"
          v-if="details.status === status.REVOKED">
          <b-row>
            <b-col>
              <p>{{ details.decisionMessage }}</p>
            </b-col>
          </b-row>
        </form-accordion>

        <hr v-if="details.cancelMessage && details.cancelMessage !== ''" />

        <form-accordion :title="$t('common.formsSubTitle.cancel_reason')"
          v-if="details.cancelCode && details.cancelCode !== ''">
          <b-row>
            <b-col>
              <p><b>{{ $t(getCancelCodeLabel(details.cancelCode)) }}</b></p>
              <p v-if="details.cancelMessage && details.cancelMessage !== ''">{{ details.cancelMessage }}</p>
            </b-col>
          </b-row>
        </form-accordion>

        <hr v-if="details.direction === '0' && waitingForAnswerRTP(details.status) && details.acceptMultipleInstalments === '1'" />

        <form-accordion :title="'ECHEANCIER'"
          v-if="details.direction === '0' && waitingForAnswerRTP(details.status) && details.acceptMultipleInstalments === '1'">
          <b-row>
            <b-col>
              <b-form-checkbox v-model="showInstallments"
                class="mt-sm-2"
                :value="true" :unchecked-value="false">
                {{ $t('common.ask_multiple_payments_times') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
          <br/>
          <b-row v-if="showInstallments">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="numInstallments"
                inputType="number"
                inputLabel="Nombre d'échéances">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row v-if="showInstallments">
            <b-col>
              <echeancier v-model="multPmts"
                :numPay="numInstallments" :min="1"
                :amount="details.amount" ccy="€" :deposit="0"
                :execDate="details.requestedExecutionDate">
              </echeancier>
            </b-col>
          </b-row>
        </form-accordion>

        <hr />

        <form-accordion :title="$t('common.formsSubTitle.rqst_to_pay_hstry')" :open="false">
          <b-row class="form-group">
            <b-col>

              <table class="table table-striped table-bordered table-status-history">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col" class="reponsiveColumnWidth">
                      {{ $t('common.date_label') }}
                    </th>
                    <th scope="col">
                      {{ $t('common.status.status_label') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="record in details.history" :key="record.id">
                    <td class="dateTimehistoryHeight">
                      {{ record.creationDate | formatDateTime }}
                    </td>
                    <td>
                      <b-row>
                        <b-col sm="7" class="statusHistoryLabel">
                          {{getHistoryLabel(record.status)}}
                          <f7-icon :icon="getHistoryIcon(record.status)"
                            class="icon-transaction-detail">
                          </f7-icon>
                        </b-col>
                        <b-col sm="5">
                          <f7-button class="xmlButtonBackground" @click="viewXML()"
                            v-if="showPain001View(record)">
                            {{ $t('common.button_technical_details') }}
                          </f7-button>
                        </b-col>
                      </b-row>
                      <div class="item-content"
                        v-if="(record.status==='10' || record.status==='11') && record.comment!==''">
                        <div class="item-inner" style="display:block;">
                          <div class="item-title-row" style="font-style:italic;">
                            {{ $t('common.ngttn_cmmnt') }}:
                          </div>
                          <div class="item-title-row">
                            <div style="color:#8e8e93">
                              {{ record.comment }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <li class="item-content" v-if="(details.status==='1' || details.status==='2' || details.status==='3') &&
                            details.responseComment !== ''">
                          <div class="item-inner" style="display:block;">
                            <div class="item-title-row">
                              {{ $t('common.rspns_cmmnt') }}:
                            </div>
                            <div class="item-title-row">
                              <div style="color:#8e8e93">
                                {{ details.responseComment }}
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </form-accordion>
      </div>
    </template>

    <template slot="footerButtons">
      <div v-if="!details.id || (showOtherDebtors() && otherRTP.length === 0)"></div>
      <div v-else>
        <b-row v-if="details.direction === '0'" class="inboxDetailButton">
          <b-col md="10" offset-md="1">
            <b-row class="justify-content-start">
              <b-col md="3" v-if="LMSGsupplierconfig">
                <!-- ACCEPT AND PAY -->
                <f7-button class="button-action milkyBlockBlack"
                  v-if="waitingForAnswerRTP(details.status) && details.pay !== 'none' && !$engine.user.isOtp"
                  @click="showPaymentAxepta()">
                  <f7-icon fa="check"></f7-icon>
                  {{ $t('common.accpt_nd_pay') }}
                </f7-button>
                <!-- PAY -->
                <f7-button class="button-action milkyBlockBlack"
                  v-if="(details.status === status.ACCEPTED || details.status === status.MODIFIED) && details.pay !== 'none' && !$engine.user.isOtp"
                  @click="showPaymentAxepta()">
                  <f7-icon fa="check"></f7-icon>
                  {{ $t('common.pay') }}
                </f7-button>
              </b-col>
              <b-col md="3" class="form-group" v-else>
                <!-- ACCEPT AND PAY -->
                <f7-button class="button-action milkyBlockBlack"
                  v-if="showButtonAcceptAndPay()"
                  @click="transactionAcceptedAndPay()">
                  <f7-icon fa="check"></f7-icon>
                  {{ $t('common.accpt_nd_pay') }}
                </f7-button>
                <!-- PAY -->
                <f7-button class="button-action milkyBlockBlack"
                  v-if="showButtonPay()"
                  @click="Pay()">
                  <f7-icon fa="check"></f7-icon>
                  {{ $t('common.pay') }}
                </f7-button>
              </b-col>

              <b-col md="3" class="form-group" v-if="showButtonAccept()">
                <!-- ACCEPT -->
                <f7-button class="button-action milkyBlockBlack"
                  @click="transactionAccepted()">
                  <f7-icon fa="check"></f7-icon>
                  {{ $t('common.accpt') }}
                </f7-button>
              </b-col>

              <!-- REFUSE -->
              <b-col md="3" class="form-group" v-if="showButtonRefuse()">
                <f7-button class="button-action milkyBlockBlack"
                  @click="transactionRefused">
                  <f7-icon fa="hand-stop-o"></f7-icon>
                  {{ $t('common.refus') }}
                </f7-button>
              </b-col>

              <!-- NEGOCIATE -->
              <b-col md="3" class="form-group" v-if="showButtonNegotiate()">
                <f7-button class="button-action milkyBlockBlack"
                  href="/payments/negotiate/">
                  <f7-icon fa="repeat"></f7-icon>
                  {{ $t('common.negot') }}
                </f7-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <!-- Détails pour une demande envoyée -->
        <!-- Vraie négociation inactive : Simple modification actuellement utilisée -->
        <div v-if="details.direction === '1'" class="inboxDetailButton">
          <b-row>
            <b-col md="10" offset-md="1">
              <b-row>
                <b-col md="3" class="form-group">
                  <!-- CANCEL -->
                  <f7-button class="button-action milkyBlockBlack"
                    @click="cancelRequestToPay(details.endToEndId)"
                    v-if="showButtonCancel()">
                    {{ $t('requestToPay.cancel_rtp') }}
                  </f7-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="justify-content-start"
            v-if="showButtonAcceptNegotiation()">
            <b-col md="3" offset-md="1" class="form-group">
              <f7-button class="button-action milkyBlockBlack"
                @click="acceptNegotiation()">
                <f7-icon fa="handshake-o"></f7-icon>
                Accept Negotiation
              </f7-button>
            </b-col>

            <b-col md="4" class="form-group">
              <f7-button class="button-action milkyBlockBlack"
                href="/payments/negotiate/">
                <f7-icon fa="repeat"></f7-icon>
                Negotiate
              </f7-button>
            </b-col>

            <b-col md="3" class="form-group">
              <f7-button class="button-action milkyBlockBlack"
                @click="refuseNegotiation()">
                <f7-icon fa="hand-stop-o"></f7-icon>
                Refuse and insist on the original request
              </f7-button>
            </b-col>
          </b-row>

          <b-row class="justify-content-start" v-if="waitingForAnswerRTP(details.status)">
            <!-- <div class="col-md-3 offset-md-1">
              <button rounds class="button-action firstButtonMarginTop milkyBlockBlack"
                @click="cancelRequestToPay(details.endToEndId)">
                {{ $t('requestToPay.cancel_rtp') }}
              </button>
            </div> -->
            <b-col md="3" offset-md="4" class="form-group">
              <f7-button
                v-if="false"
                class="button-action milkyBlockBlack"
                @click="remindReceiver(details.id)">
                <f7-icon fa="bell"></f7-icon>
                {{ $t('requestToPay.remind_rcvr') }}
              </f7-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </page-outline>
</template>

<script>
import b64toBlob from 'b64-to-blob'
// import base64url from 'base64url'
import moment from 'moment'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import spinner from '@/components/common/spinner.vue'

import bankDatas from '@/pages/requests/components/data/bankDatas.json'
import Echeancier from '@/pages/requests/EcheancierForm.vue'
import TransactionsList from '@/pages/requests/TransactionsList.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {formatIbanHiddenEnd, formatLettrage} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'
import services from '@/helpers/services'
import {statusLabel, statusIcon, getCancelLabel} from '@/helpers/labels'
import status from '@/helpers/status'


export default {
  name: 'transaction-details',
  components: {
    'echeancier': Echeancier,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': spinner,
    'transactions-list': TransactionsList
  },
  data () {
    return {
      action: '',
      label: '',
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      multPmts: [],
      numInstallments: '1',
      showInstallments: false,
      ImmPmtAccepted: '',
      bankAccountSelectDebit: '',
      paymentMethod: '',
      attachement: '',
      attachementName: '',
      attachementReference: '',
      attachementId: '',
      showIbanBox: false,
      payStatus: '0',
      status: status,
      oldAmountGet: '',
      oldDateGet: '',
      otherRTP: [],
      randomId: Math.random().toString(36).substr(2, 10),
      services: services
    }
  },
  created () {
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.emit('service:change', 'Payments')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    if (this.details.id) {
      this.oldAmountGet = this.details.amount
      this.oldDateGet = this.details.requestedExecutionDate
    }
    if (this.details.dbBkAcct !== '') {
      this.bankAccountSelectDebit = this.details.debtorBankAccount
    } else {
      if (this.$engine.bankAccounts.getDefaultBankAccount().iban !== undefined) {
        this.bankAccountSelectDebit = this.$engine.bankAccounts.getDefaultBankAccount().iban
      } else {
        this.bankAccountSelectDebit = ''
      }
    }
    this.paymentMethod = this.$engine.settings.get(1).paymentMethod

    this.$bus.$on('pay-transaction', e => {
      console.log(this.payStatus)
      if (this.payStatus === '1') {
        this.transactionAcceptedAndPay()
      } else {
        this.Pay()
      }
    })

    this.$bus.$on('load-message', e => {
      this.seeDetails(e, true)
    })

    /* Récupération des autres paiements */
    if (this.showOtherDebtors()) {
      let filterConditions = {
        IdGroup: this.details.IdGroup
      }
      this.$engine.services.payments.update(
        2,
        100,
        1,
        filterConditions
      ).then(resp => {
        this.otherRTP = resp.data.payments
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    }
  },
  beforeDestroy () {
    // this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.attachementName = ''
    this.attachment = ''
    this.attachementReference = ''
    this.$bus.$off('pay-transaction')
  },
  computed: {
    bankAccounts () {
      return this.$engine.bankAccounts.get()
    },
    details () {
      return this.$settings.clickedMessage
    },
    isDebtorAnon () {
      return (this.details.debtorName === undefined || this.details.debtorName === '')
    },
    isInstantPayment () {
      let today = moment().format('YYYY-MM-DD')
      if (this.details.executionDateResponse.length > 0) {
        return moment(this.details.executionDateResponse).format('YYYY-MM-DD') === today
      } else {
        return moment(this.details.requestedExecutionDate).format('YYYY-MM-DD') === today
      }
    },
    oldAmount () {
      if (this.oldAmountGet === '' && this.details.amount) {
        this.oldAmountGet = this.details.amount
      }
      return this.oldAmountGet
    },
    oldDate () {
      if (this.oldDateGet === '' && this.details.requestedExecutionDate) {
        this.oldDateGet = this.details.requestedExecutionDate
      }
      return this.oldDateGet
    },
    titleIcon () {
      if (this.details.direction === '0') {
        return 'icon-inbox'
      } else {
        return 'icon-sent'
      }
    },
    titleLabel () {
      if (this.details.direction === '0') {
        return this.$t('received.pymnt_rqst_rcvd_verb_past')
      } else {
        return this.$t('sent.rqst_pymnt_snt_verb_past')
      }
    }
  },
  methods: {
    formatLettrage: formatLettrage,
    waitingForAnswerRTP (requestStatus) {
      return ((requestStatus === status.RECEIVED) || (requestStatus === status.WAITING))
    },
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(filePath.split('/')[filePath.split('/').length - 1], 'Following file successfully saved.')
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      /* eslint-enable no-undef */
    },
    openDoc (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      let that = this
      let win = window
      this.$f7.showPreloader(this.$i18n.t('loading.loading_file'))
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.$f7.hidePreloader()
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else { // browser
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            let url = window.URL.createObjectURL(blob)
            that.$f7.hidePreloader()
            win.open(url)
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
    },
    getBankName (iban) {
      let code = iban.substring(4, 9)
      let bankName = bankDatas.Banks.find(e => e.code === code).name
      return bankName
    },
    getCancelCodeLabel (code) {
      return getCancelLabel(code)
    },
    view (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.loading_file'))
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.$f7.hidePreloader()
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else { // browser
            that.$f7.hidePreloader()
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            let url = window.URL.createObjectURL(blob)
            let fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.documentName) // or any other extension
            fileLink.click()
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
    },
    viewXML () {
      let that = this
      this.$f7.showPreloader(that.$i18n.t('common.opnng_fl'))
      // let userId = that.$engine.user.get().id
      // this.$engine.services.getEnvelope(idMessage, typeMessage, userId)
      this.$engine.services.getXMLDetail('payment', 'pain001', that.details.id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({type: {
            data: response.data
          }})
          /* TLV 22/09/2020
          * Lignes ci-dessous a decommenter quand on testera le telechargement de
          * fichiers sur mobile */
          /* if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              typeMessage + '_' + idMessage + '.xml',
              response.data.data,
              response.data.data.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else { */ // browser
          /* let blob = base64url.decode(response.data['envelopes'][0].message)
          const linkSource = 'data:text/csv;charset:utf-8,' + blob */
          let blob = b64toBlob(response.data.data.split(',')[1], 'text/xml')
          let linkSource = window.URL.createObjectURL(blob)
          let fileLink = document.createElement('a')
          fileLink.href = linkSource
          let today = moment().format()
          fileLink.setAttribute('download', 'Technical_View' + today + '.xml') // or any other extension
          fileLink.click()
          // }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          console.log(error)
        })
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (that.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
      } else {
        // directory = cordova.file.externalRootDirectory
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (that.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          that.checkForWritePermissions(function () {
            try {
              window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
                directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
                  that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
                    console.log('sucess saving file: ', filePath)
                  }, function (error, _data) {
                    console.error('error on saving file' + error.code)
                    alert('Unable to save file: ' + error.code)
                  })
                }, function (error, _data) {
                  console.error('error on accessing download directory' + error.code)
                  alert('Unable to get/create download directory: ' + error.code)
                })
              }, (e, file) => { // error resolveLocalFileSystemURL
              })
            } catch (error) { // get dir
              console.error(error)
            }
          }, function () {
            alert('App needs access to the phone\'s file storage in order to save files.')
          })
        } catch (error) { // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      if (this.$f7.device.os === 'android') {
        cordova.plugins.diagnostic.requestRuntimePermission(function (status) {
          switch (status) {
            case cordova.plugins.diagnostic.permissionStatus.GRANTED:
              console.log('Permission granted')
              sucess()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED:
              console.log('Permission denied')
              error()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
              console.log('Permission permanently denied')
              error()
              break
          }
        }, function (error) {
          console.error('The following error occurred: ' + error)
        },
          cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
        )
      } else if (this.$f7.device.os === 'ios') {
        sucess()
      }
      /* eslint-enable no-undef */
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
        directoryEntryReference = directoryEntry
        directoryEntry.getFile(fileName, { create: true, exclusive: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
              success(e.target.localURL, fileType, fileName)
            }
            fileWriter.onerror = function (e) {
              error()
            }
            let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
            fileWriter.write(blob)
          }, (e, file) => {
          })
        }, (e, file) => {
          navigator.notification.confirm('This file already exists do you want to override it ? (' + fileName + ')', function (index) {
            console.log('Do you want to override the following file: ' + fileName + ' (' + index + ')')
            switch (index) {
              case 1: // No
                console.log('No. Returning to idle state.')
                break
              case 2: // Yes -> overrides  the file
                console.log('Yes. Overriding file.')
                directoryEntryReference.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function (e) {
                      success(e.target.localURL, fileType, fileName)
                    }
                    fileWriter.onerror = function (e) {
                      error()
                    }
                    let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
                    fileWriter.write(blob)
                  }, (e, file) => {
                  })
                }, (e, file) => {
                })
                break
            }
          }, 'Information', ['No', 'Yes'])
        })
      }, (e, file) => { // error resolveLocalFileSystemURL
      })
      /* eslint-enable no-undef */
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(entry.nativeURL.replace(/%20/g, ' '), fileType, {
          error: function (e) {
            // TODO : screen user stuff
          },
          success: function (s) {
            // TODO : screen user stuff
          }
        })
      })
    },
    getCurrencyIcon (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        default:
          return ccy
      }
    },
    getStatusLabel (status, negotStatus) {
      return statusLabel(this.$i18n, status, negotStatus)
    },
    getStatusIcon (status, negotStatus) {
      return statusIcon(status, negotStatus)
    },
    getHistoryLabel (status) {
      return statusLabel(this.$i18n, status, '0')
    },
    getHistoryIcon (status) {
      return statusIcon(status)
    },
    confirmNegotiation () {
      let that = this
      if (that.bankAccountSelectDebit.length === 0) {
        this.$f7.alert('', 'Bank account missing')
        return
      }
      if (parseFloat(this.$engine.settings.get(1).validationThreshold) > parseFloat(this.details.amount)) {
        let status = '2'
        if (that.$settings.clickedMessage.amount === that.details.pmtNegot.amountDebtor &&
        that.$settings.clickedMessage.requestedExecutionDate === that.details.pmtNegot.debtorPaymentsDate) {
          status = '1'
        }
        let amount = parseFloat(that.details.pmtNegot.amountDebtor)
        amount = parseFloat(amount) % 1 === 0 ? amount : parseFloat(amount).toFixed(2)
        let debtorBankAccountToSend = that.bankAccountSelectDebit
        // debtorBankAccountToSend = that.bankAccountSelectDebit
        that.$engine.services.payments.answerToPayments(
          that.$settings.clickedMessage.id,
          status,
          amount,
          that.details.pmtNegot.debtorPaymentsDate,
          '',
          debtorBankAccountToSend,
          that.$engine.settings.get(1).isToGenerateXML,
          that.details.pmtNegot.immediatePayments === 'true',
          that.details.pmtNegot.multiPayments
        ).then(response => {
          loadPage(that, {url: '/inbox/2/1/'})
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        this.$f7.modal({
          title: this.$t('common.cnfrm_trnsctn'),
          text: this.$t('common.comment_size'),
          afterText: '<div class="item-input"><textarea class="confirmNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {
              }
            },
            {
              text: 'Ok',
              onClick: function () {
                let status = '2'
                if (that.$settings.clickedMessage.amt === that.details.pmtNegot.amountDebtor &&
                that.$settings.clickedMessage.requestedExecutionDate === that.details.pmtNegot.debtorPaymentsDate) {
                  status = '1'
                }
                let amount = parseFloat(that.details.pmtNegot.amountDebtor)
                amount = parseFloat(amount) % 1 === 0 ? amount : parseFloat(amount).toFixed(2)
                let debtorBankAccountToSend = ''
                // if (that.details.dbBkAcct === '') {
                debtorBankAccountToSend = that.bankAccountSelectDebit
                // }
                that.$engine.services.payments.answerToPayments(
                  that.$settings.clickedMessage.id,
                  status,
                  amount,
                  that.details.pmtNegot.debtorPaymentsDate,
                  that.Dom7('.confirmNegotiation').val(),
                  debtorBankAccountToSend,
                  that.$engine.settings.get(1).isToGenerateXML,
                  that.details.pmtNegot.immediatePayments === 'true',
                  that.details.pmtNegot.multiPayments
                ).then(response => {
                  loadPage(that, {url: '/inbox/2/1/'})
                })
                .catch(error => {
                  errorMessageAlert(error, that)
                })
              }
            }
          ]
        })
      }
    },
    transactionAcceptedAndPay () {
      this.payStatus = '1'
      this.transactionAccepted()
    },
    transactionAccepted () {
      let that = this
      if (that.bankAccountSelectDebit.length === 0) {
        that.$f7.alert('', that.$t('errors.bnk_act_mssng'))
        return
      }

      if (that.details.amount === '' || that.details.amount <= 0) {
        that.$f7.alert('', that.$t('errors.invld_amnt'))
        return
      }

      if (that.details.requestedExecutionDate === '' || moment(that.details.requestedExecutionDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
        that.$f7.alert('', that.$t('errors.invld_dt'))
        return
      }

      let bankAccountIbans = []
      for (let i = 0; i < that.bankAccounts.length; i++) {
        bankAccountIbans.push(that.bankAccounts[i].iban)
      }
      // comment buggy account add
      // if (!bankAccountIbans.includes(that.bankAccountSelectDebit)) {
      //   that.$f7.modal({
      //     title: 'Bank account doesn\'t exist',
      //     text: 'This IBAN is not saved. Do you want to save this IBAN?',
      //     buttons: [
      //       {
      //         text: 'Save',
      //         onClick: function () {
      //           that.$engine.bankAccounts
      //           .create({name: 'Account_' + Math.random().toString(36).substring(7), iban: that.bankAccountSelectDebit})
      //           .then(resp => {
      //             that.$bus.$emit('refresh-cache-bank-accounts')
      //             that.confirmModal()
      //           })
      //           .catch(err => {
      //             errorMessageAlert(err, that)
      //           })
      //         }
      //       },
      //       {
      //         text: 'Cancel',
      //         onClick: function () {
      //         }
      //       }
      //     ]
      //   })
      // } else {
      this.confirmModal()
      // }
    },
    confirmModal () {
      let that = this
      if (parseFloat(this.$engine.settings.get(1).validationThreshold) > parseFloat(this.details.amount)) {
        that.action = 'accept'
        that.ImmPmtAccepted = 'true'
        that.answerToPayments('1', {comment: '', isToGenerateXML: that.$engine.settings.get(1).isToGenerateXML})
      } else {
        this.$f7.modal({
          title: this.$t('common.cnfrm_trnsctn'),
          text: this.$t('common.comment_size'),
          afterText: '<div class="item-input"><textarea class="acceptComment commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {}
            },
            {
              text: 'Ok',
              onClick: function ($event) {
                that.action = 'accept'
                that.ImmPmtAccepted = 'true'
                that.answerToPayments('1', {comment: that.Dom7('.acceptComment').val(), isToGenerateXML: that.$engine.settings.get(1).isToGenerateXML})
              }
            }
          ]
        })
      }
    },
    refuseNegotiation () {
      let that = this
      if (parseFloat(this.$engine.settings.get(1).validationThreshold) > parseFloat(this.details.amount)) {
        that.$engine.services.payments.negotiatePayments(
          that.$settings.clickedMessage.id,
          'negotResp',
          'KO',
          Number(that.$settings.clickedMessage.amount),
          false,
          that.$settings.clickedMessage.requestedExecutionDate,
          ''
        ).then(response => {
          if (response.status === 200) {
            that.$f7.alert('', 'Negotiation Refused', function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/inbox/2/1/'})
            })
          }
        }).catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        that.$f7.modal({
          title: 'Refuse Negotiation',
          text: that.$t('common.comment_size'),
          afterText: '<div class="item-input"><textarea class="refuseNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {
              }
            },
            {
              text: 'Ok',
              onClick: function () {
                that.$engine.services.payments.negotiatePayments(
                  that.$settings.clickedMessage.id,
                  'negotResp',
                  'KO',
                  Number(that.$settings.clickedMessage.amount),
                  false,
                  that.$settings.clickedMessage.requestedExecutionDate,
                  that.Dom7('.refuseNegotiation').val()
                ).then(response => {
                  if (response.status === 200) {
                    that.$f7.alert('', 'Negotiation Refused', function () {
                      that.$f7.closeModal()
                      loadPage(that, {url: '/inbox/2/1/'})
                    })
                  }
                }).catch(error => {
                  errorMessageAlert(error, that)
                })
              }
            }
          ]
        })
      }
    },
    Pay () {
      let that = this
      let status = that.$settings.clickedMessage.status === '2' ? (that.$settings.clickedMessage.instantPayment === '1' ? '14' : '13')
        : (that.$settings.clickedMessage.instantPayment === '1' ? '11' : '10')
      that.$engine.services.payments.answerToPayments(
        that.$settings.clickedMessage.id,
        status,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        [],
        '1'
      ).then(response => {
        if (response.status === 200) {
          that.$f7.alert('', that.$t('requestToPay.accept_pay'), function () {
            loadPage(that, {url: '/inbox/2/1/'})
          })
        }
      })
    },
    acceptNegotiation () {
      let that = this
      if (parseFloat(this.$engine.settings.get(1).validationThreshold) > parseFloat(this.details.amount)) {
        that.$engine.services.payments.negotiatePayments(
          that.$settings.clickedMessage.id,
          'negotResp',
          'OK',
          Number(that.details.pmtNegot.amountDebtor),
          false,
          that.details.pmtNegot.debtorPaymentsDate,
          '',
          that.details.pmtNegot.multiPayments
        ).then(response => {
          if (response.status === 200) {
            that.$f7.alert('', 'Negotiation Accepted', function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/inbox/2/1/'})
            })
          }
        }).catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        that.$f7.modal({
          title: 'Confirm Negotiation',
          text: 'Comment (optional, 255 chars maximum)',
          afterText: '<div class="item-input"><textarea class="acceptNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {
              }
            },
            {
              text: 'Ok',
              onClick: function () {
                that.$engine.services.payments.negotiatePayments(
                  that.$settings.clickedMessage.id,
                  'negotResp',
                  'OK',
                  Number(that.details.pmtNegot.amountDebtor),
                  false,
                  that.details.pmtNegot.debtorPaymentsDate,
                  that.Dom7('.acceptNegotiation').val(),
                  that.details.pmtNegot.multiPayments
                ).then(response => {
                  if (response.status === 200) {
                    that.$f7.alert('', 'Negotiation Accepted', function () {
                      that.$f7.closeModal()
                      loadPage(that, {url: '/inbox/2/1/'})
                    })
                  }
                }).catch(error => {
                  errorMessageAlert(error, that)
                })
              }
            }
          ]
        })
      }
    },
    transactionRefused () {
      let that = this
      /* if (parseFloat(this.$engine.settings.get(1).validationThreshold) > parseFloat(this.details.amount)) {
        that.action = 'refuse'
        that.ImmPmtAccepted = 'true'
        that.answerToPayments('3', {comment: '', isToGenerateXML: that.$engine.settings.get(1).isToGenerateXML})
      } else { */
      this.$f7.modal({
        cssClass: 'popupWindow',
        title: '<div class="popupWindowTitle">' + this.$t('common.rvk_trnsctn') + '</div>',
        text: '<p>' + this.$t('common.sure_to_refuse_transaction') + '</p>',
        afterText: '<div class="item-input"><textarea class="refuseComment commentTextArea" placeholder="' + this.$t('common.comment_size') + '"></textarea></div>',
        buttons: [
          {
            text: 'Cancel',
            onClick: function () {
            }
          },
          {
            text: 'Ok',
            onClick: function () {
              that.action = 'refuse'
              that.ImmPmtAccepted = 'true'
              that.answerToPayments('3', {comment: that.Dom7('.refuseComment').val(), isToGenerateXML: that.$engine.settings.get(1).isToGenerateXML})
            }
          }
        ]
      })
      // }
    },
    closeModal (hidden) {
      const that = this
      that.$f7.closeModal()
      /* when we use modify button, panel was displayed on the page, in front of user's actions */
      if (hidden) {
        document.getElementById('modif-actions').style.display = 'none'
      }
    },
    answerToPayments (status, optionals = {ImmPmtAc: 'false', comment: '', isToGenerateXML: '1'}) {
      let today = moment().format('YYYY-MM-DD')
      if (moment(this.$settings.clickedMessage.requestedExecutionDate).format('YYYY-MM-DD') < today) {
        this.$f7.alert('', this.$t('errors.invld_exec_dt'))
        return
      }
      let execDate = optionals.ImmPmtAc === 'true' ? today : moment(this.$settings.clickedMessage.requestedExecutionDate).format('YYYY-MM-DD')
      let that = this
      let debtorBankAccountToSend = ''
      debtorBankAccountToSend = that.bankAccountSelectDebit
      let amount = this.$settings.clickedMessage.amount !== '' ? this.$settings.clickedMessage.amount : this.details.amount
      amount = parseFloat(amount) % 1 === 0 ? amount : parseFloat(amount).toFixed(2)
      let multiplePaymentsToSend = []
      if (that.details.acceptMultipleInstalments !== undefined && that.showInstallments && that.multPmts.length > 0 && status !== '3') {
        multiplePaymentsToSend = that.multPmts.map((pay) => { return { amount: pay.amount, date: pay.date, currency: that.details.currency } })
      }
      var TxSts = 0
      if (parseInt(status) === 3) {
        TxSts = status
      } else {
        let reqExecDateStr = new Date(that.details.requestedExecutionDate).toLocaleDateString()
        let oldDateStr = new Date(that.oldDate).toLocaleDateString()
        if ((that.details.acceptMultipleInstalments && that.showInstallments && that.multPmts.length > 0) ||
          (oldDateStr && reqExecDateStr !== oldDateStr) ||
          (that.oldAmount && that.details.amount !== that.oldAmount)
        ) {
          TxSts = 2
        } else {
          TxSts = 1
        }
      }
      that.$engine.services.payments.answerToPayments(
        that.$settings.clickedMessage.id,
        TxSts,
        amount,
        this.details.currency,
        execDate,
        optionals.comment,
        debtorBankAccountToSend,
        optionals.isToGenerateXML,
        optionals.ImmPmtAc,
        multiplePaymentsToSend,
        this.payStatus
      ).then(response => {
        if (response.status === 200) {
          switch (that.action) {
            case 'accept':
              // that.$f7.alert('Your payments will become effective on ' + execDate, 'Transaction Accepted')
              this.$f7.modal({
                title: this.$t('common.status.accepted_request'),
                text: '<span class="preloader"></span>'
              })
              break
            case 'modify':
              // that.$f7.alert('Your payments will become effective on ' + execDate, 'Transaction validated with modification')
              this.$f7.modal({
                title: this.$t('requestToPay.pymnts_effctv_on') + execDate,
                text: '<span class="preloader"></span>'
              })
              break
            case 'refuse':
              // that.$f7.alert('', 'Transaction Revoked')
              this.$f7.modal({
                title: this.$t('common.trnsctn_rvkd'),
                text: '<span class="preloader"></span>'
              })
              break
            default:
              // that.$f7.alert('', 'Unknown Action')
              this.$f7.modal({
                title: this.$t('common.unknwn_actn'),
                text: '<span class="preloader"></span>'
              })
          }
          loadPage(this, {url: '/inbox/2/1/'})
        }
        setTimeout(function () {
          that.$f7.closeModal()
          // loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          that.$engine.settings.set({pendingChange: true})
          that.$engine.settings.set({inboxNormalCount: null})
          loadPage(that, {url: '/payments/inbox/0'})
        }, 2000)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    seeDetails (message, isReceived) {
      if (message.id) {
        message.executionDateResponse = message.executionDateResponse.substring(0, 10)
      }
      this.$engine.settings.set({
        clickedMessage: message
      })
      this.$engine.settings.set({
        msgFromInbox: isReceived
      })

      let that = this
      if (message.isRead !== '1') {
        message.isRead = '1'
        this.$engine.services.payments.setPaymentsRead({
          id: message.id,
          isRead: 1
        })
        .then(response => {})
        .catch(error => {
          errorMessageAlert(error, that, this.$i18n)
        })
      }
      this.$forceCompute('details')
      this.$forceCompute('oldAmount')
      this.$forceCompute('oldDate')
    },
    showBankAccountSelectionList () {
      let that = this
      that.showIbanBox = true
      // that.$refs.ibanBox.style.display = 'block'
      // that.Dom7($event.target).next().next().css('display', 'block')
    },
    showButtonAccept () {
      return this.waitingForAnswerRTP(this.details.status)
    },
    showButtonAcceptAndPay () {
      return this.waitingForAnswerRTP(this.details.status) &&
        this.details.pay !== 'none' &&
        !this.$engine.user.isOtp
    },
    showButtonAcceptNegotiation () {
      return this.waitingForAnswerRTP(this.details.status) &&
        this.details.negotStatus === '10' &&
        this.details.pymtModAcpt === 'true'
    },
    showButtonCancel () {
      return (this.details.status === status.WAITING ||
        this.details.status === status.RECEIVED) && !this.isDebtorAnon
    },
    showButtonNegotiate () {
      return this.details.acceptMultipleInstalments === '1' &&
        (this.waitingForAnswerRTP(this.details.status) ||
        this.details.status === status.MODIFIED) &&
        false
    },
    showButtonPay () {
      return (this.details.status === status.ACCEPTED ||
        this.details.status === status.MODIFIED) &&
        this.details.pay !== 'none' &&
        !this.$engine.user.isOtp
    },
    showButtonRefuse () {
      return this.waitingForAnswerRTP(this.details.status)
    },
    showInstantPayment (iban) {
      let code = iban.substring(4, 9)
      if (!bankDatas.Banks.find(e => e.code === code)) {
        return false
      }
      let instantPayment = bankDatas.Banks.find(e => e.code === code).sctinst
      return instantPayment
    },
    showNegotiation () {
      return (this.waitingForAnswerRTP(this.details.status) && this.details.negotStatus === '10') ||
        (this.waitingForAnswerRTP(this.details.status) && this.details.negotStatus === '11')
    },
    showOtherDebtors () {
      return this.details.IdGroup
    },
    showPain001View (record) {
      return (record.status === status.ORDER_GENERATED ||
        record.status === status.INST_ORDER_GENERATED)
    },
    showPaymentAxepta () {
      this.payStatus = '1'
      /* Remplacer reason par la ref de la facture */
      let amount = this.$settings.clickedMessage.amount !== '' ? this.$settings.clickedMessage.amount : this.details.amount
      this.$bus.$emit('popup-payment-axepta', {
        amount: amount,
        currency: this.details.currency,
        description: this.details.reason,
        ref: this.details.reason,
        selectScreen: true,
        transId: this.details.endToEndId
      })
    },
    selectBankAccount (event) {
      let that = this
      that.bankAccountSelectDebit = that.$$(event.target).parent().data('iban')
      // that.Dom7('.bankAccountDebitSelectionListContainer').css('display', 'none')
      that.showIbanBox = false
      // that.$$(event.target).parent().parent().parent().css('display', 'none')
    },
    closeSelectionListContainer () {
      let that = this
      that.showIbanBox = false
      // that.Dom7('.bankAccountDebitSelectionListContainer').css('display', 'none')
    },
    cancelRequestToPay (endToEndId) {
      let that = this
      let reasonCodeHtml = '<select class="cancelReasonCode form-group" style="width:100%">' +
      '<option value="DU10">' + that.$t('requestToPay.dupplicate') + '</option>' +
      '<option value="TE20">' + that.$t('requestToPay.tchncl_err') + '</option>' +
      '<option value="WA30">' + that.$t('requestToPay.wrng_amnt') + '</option>' +
      '<option value="UT40">' + that.$t('requestToPay.underlying_trncstn_mdf') + '</option>' +
      '<option value="PI50">' + that.$t('requestToPay.pyr_id_incrrct') + '</option>' +
      '<option value="AP60">' + that.$t('requestToPay.alrdy_payd_by_othr') + '</option>' +
      '<option value="SF70">' + that.$t('requestToPay.suspicion_fraud') + '</option>' +
      '</select>' +
      '<textarea class="cancelReasonLabel commentTextArea" placeholder="' + this.$t('common.comment_size') + '"></textarea>'
      this.$f7.modal({
        cssClass: 'popupWindow',
        title: '<div class="popupWindowTitle">' + this.$t('requestToPay.cancel_rtp') + '</div>',
        text: '<p>' + this.$t('requestToPay.cncl_question') + '</p>',
        afterText: reasonCodeHtml,
        buttons: [
          {
            text: that.$t('common.cncl'),
            onClick: function () {
            }
          },
          {
            text: 'OK',
            onClick: function () {
              that.$engine.services.payments.paymentsCancel(that.details.debtorIdentifier,
              that.details.creditorIdentifier,
              endToEndId,
              that.Dom7('.cancelReasonCode').val(),
              that.Dom7('.cancelReasonLabel').val())
              .then(response => {
                if (response.status === 200) {
                  that.$f7.modal({
                    title: that.$t('common.status.aborted_request'),
                    text: '<span class="preloader"></span>'
                  })
                  setTimeout(function () {
                    that.$f7.closeModal()
                    loadPage(that, {url: '/inbox/2/1/'})
                  }, 2000)
                }
              }).catch(error => {
                errorMessageAlert(error, that)
              })
            }
          }
        ]
      })
    },
    remindReceiver (id) {
      let that = this
      that.$engine.services.payments.paymentsRemind(id)
      .then(response => {
        if (response.status === 200) {
          this.$f7.modal({
            title: 'Receiver reminded',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/inbox/2/1/'})
          }, 2000)
        }
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    },
    hideIban (iban) {
      return formatIbanHiddenEnd(iban)
    }
  }
}
</script>
<style>
.createInvoiceBand:hover {
  text-decoration: underline;
}
.bankAccountDebitSelectionList {
  margin: 0;
  max-height: 100px;
  overflow-y: scroll;
  padding-left: 0 !important;
}
.bankAccountDebitSelectionList::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.bankAccountDebitSelectionList::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,.5);
  border-radius: 4px;
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}
.bankAccountDebitSelectionListContainer {
  background-color: #ffffff;
  border: 1px solid #a9a9a9;
  margin-top: 1px;
  z-index: 20;
}
.bankAccountDebitSelectionListItem {
  padding: 8px 8px;
}
.closeSelectionListContainerLabel {
  border-bottom: 1px solid #a9a9a9;
  padding: 3px 8px 3px 8px;
}
.closeSelectionListContainerLabelName {
  line-height: 21px;
}
.rightButton {
  padding: 1px 5px !important;
  position: absolute;
  right: 8px;
  line-height: normal !important;
    top: 3px;
}
.transactionDetailSubHeader {
  display: block !important;
  font-weight: bold !important;
}

.popupWindowTitle {
  text-align: left;
}
.modal-inner {
  padding: 20px;
}

@media (max-height:280px)  {
  .commentTextArea {
    height: 4rem;
  }
  .popupWindow {
    top: 40% !important;
  }
}
@media (min-height:281px) and (max-height:320px)  {
  .commentTextArea {
    height: 6rem;
  }
  .popupWindow {
    top: 35% !important;
  }
}
@media (min-height:321px) and (max-height:400px)  {
  .commentTextArea {
    height: 7rem;
  }
}
@media (max-width: 500px) {
  .popupWindow {
    top: 25%;
  }
}
@media (max-width:1199px)  {
  .popupWindow {
    display: block;
    width: 80%;
    margin-left: -40%;
    text-align: left;
  }
}
@media (min-width:1200px)  {
  .popupWindow {
    display: block;
    width: 40%;
    margin-left: -20%;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// RequestToPayDetailPage.vue?0accf08e